export const SORT_BY = {
  NAME: "SORT_BY_NAME",
  DATE_ASC: "SORT_BY_DATE_ASC",
  DATE_DESC: "SORT_BY_DATE_DESC",
  STATUS: "SORT_BY_STATUS",
  ROLE: "SORT_BY_ROLE"
};

export const SET_ACCOUNTS_SORT = "SET_ACCOUNTS_SORT";
export const SET_PEOPLE_SORT = "SET_PEOPLE_SORT";

export const setAccountsSort = sortBy => ({
  type: SET_ACCOUNTS_SORT,
  sortBy: sortBy
});

export const setPeopleSort = sortBy => ({
  type: SET_PEOPLE_SORT,
  sortBy: sortBy
});



// WEBPACK FOOTER //
// ./src/actions/sort.js